import React from 'react';
import { Col, Popover, Row, Text, useTheme } from '@metaicg/sensei-ui';
import Avatar from '@/shared/components/avatar';
import ProfileMenu from '@/shared/components/layout/components/profile/profile-menu';
import useAuth from '@/features/auth/hooks/use-auth';
import AnimatedPage from '@/shared/components/layout/components/animated-page';
import { useAuthProfile } from '@/shared/hooks/use-auth-profile';

const Profile = ({ collapsed }: { collapsed?: boolean }) => {
  const { data: profile } = useAuthProfile();
  const { logout } = useAuth();
  const { theme } = useTheme();

  const logOut = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    await logout();
  };

  return (
    <Popover
      trigger="click"
      autoAdjustOverflow
      placement="rightBottom"
      color={theme.colors.neutral.palette700}
      content={<ProfileMenu data={profile || undefined} logoutHandler={logOut} />}
    >
      <Row gutter={theme.spacing.xs} wrap={false} align="middle">
        <Col flex="50px">
          <Avatar alt={profile?.displayName || profile?.email || ''} src={profile?.profilePhoto} clickable />
        </Col>

        {collapsed ? null : (
          <AnimatedPage>
            <Col flex="auto">
              <Row gutter={[0, theme.spacing.xxs]}>
                <Col span={24}>
                  <Text size="sm" className="profile-name">
                    {profile?.displayName}
                  </Text>
                </Col>
                <Col span={24}>
                  <Text size="sm" className="profile-email" color="neutral.palette300">
                    {profile?.email}
                  </Text>
                </Col>
              </Row>
            </Col>
          </AnimatedPage>
        )}
      </Row>
    </Popover>
  );
};

export default Profile;
